import React, { useState, useEffect, useCallback, useRef } from "react";
import cogoToast from "cogo-toast";
import moment from "moment-timezone";
import { Consumer } from "../../context";
import { Helmet } from "react-helmet";
import Header from "../../components/header/header";
import Controls from "../../components/controls/controls";
import SidebarAdministracion from "../../components/header/sidebarAdministracion";
import Paginador from "../../components/paginador/paginador";
import SuperCore from "../../components/core/SuperCore";
import SuperModal from "../../components/coreModal/SuperModal";
import NewReceipment from "../../components/receipmentpayment/NewReceipment";
import ReceipmentTable from "../../components/receipmentpayment/receipmentTable";
import Request from "../../core/httpClient";
import Permissions from "../../middlewares/Permissions";
import sortableData from '../../helpers/sortableDataTable';
import UnifiedDatePicker from '../../components/Calendario';
import InputMask from 'react-input-mask';

const request = new Request();


function ReceipmentPaymentInner({
	context,
	superOpenModal,
	superCloseModal,
	getUserInfo,
}) {

	const [state, setState] = useState(() => {
		const today = new Date();
		const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
		const startDateStr = lastMonth.toISOString().split('T')[0];
		const endDateStr = today.toISOString().split('T')[0];

		return {
			page: 0,
			loading: true,
			frac_name: null,
			id_fraccionamiento: localStorage.getItem("frac"),
			subfraccionamientos: [],
			subfraccionamiento: localStorage.getItem("subfrac") || '0',
			userName: "",
			userId: 0,
			viviendas: [],
			propietarios: [],
			metodosPago: [],
			linesReceipment: [],
			receipts: [],

			isOpen: false,
			dateReceipment: new Date(),
			idReceipment: 0,
			aplicado: true,
			loadingDetalle: false,
			savingReceipment: false,
			modalNewKey: 0,
			modalEditKey: 0,

			filter: "",
			filterValue: "",
			filterTipo: "",
			pageLength: 20,
			direction: {
				Unidad: 'desc',
				Propietario: 'desc',
				Fecha_recibo: 'desc',
				Total_Cobrado: 'desc',
			},
			filterColumn: { col: '', filt: '' },

			submenu: '',
			startDate: startDateStr,
			endDate: endDateStr,
			startDateObj: moment(startDateStr, 'YYYY-MM-DD').toDate(),
			endDateObj: moment(endDateStr, 'YYYY-MM-DD').toDate(),

			escritura: false,
			lectura: false,
		};
	});

	// setState parcial estilo class
	const setPartial = useCallback((patch) => {
		setState((prev) => (typeof patch === 'function' ? patch(prev) : { ...prev, ...patch }));
	}, []);

	// Ref con el state actual (para callbacks async sin re-suscribir)
	const stateRef = useRef(state);
	useEffect(() => { stateRef.current = state; }, [state]);

	// ---------- Fetch recibos ----------
	const getReceipment = useCallback(async (overrides = {}) => {
		const s = { ...stateRef.current, ...overrides };

		setPartial({ loading: true, viviendas: [], receipts: [] });


		let viviendas = [];
		const rv = await request.post("/viviendas/getViviendaBySubFraccionamiento", {
			id_fraccionamiento: s.id_fraccionamiento,
			id_subfraccionamiento: 0,
		});
		if (rv && !rv.error && !rv.empty) viviendas = rv.viviendas;

		// Propietarios
		let propietarios = [];
		const rp = await request.post("/fraccionamientos/get/propietarios", {
			idFrac: s.id_fraccionamiento,
			IdSub: 0,
		});
		if (rp && !rp.error && !rp.empty) propietarios = rp.propietario;

		// Recibos
		const response = await request.get("/receipment/get/all", {
			id_fraccionamiento: localStorage.getItem("frac"),
			id_subfraccionamiento: s.subfraccionamiento,
			desde: s.startDate,
			hasta: s.endDate,
		});

		let receiptList = [];
		if (response && !response.error) {
			if (response.data && !response.empty) {
				let filteredData = response.data;
				if (s.filterTipo) {
					filteredData = filteredData.filter((r) => r.FormaPago === s.filterTipo);
				}
				receiptList = filteredData.map((receipt) => {
					const prop = propietarios.filter((p) => p.id_vivienda === receipt.Id_Vivienda);
					const unidad = viviendas.filter((viv) => viv.id_vivienda === receipt.Id_Vivienda);
					return {
						...receipt,
						Unidad: unidad.length > 0 ? unidad[0].numero_registro : "",
						Propietario: prop.length > 0 ? prop[0].nombre : "Por definir",
						excelColumnsShow: "Unidad,Propietario,Fecha_recibo,Total_Cobrado,FormaPago,BANCO,NO_MOVIMIENTO",
						excelColumnsName: "Unidad,Propietario,Fecha aplicado,Importe,Forma pago,Banco,N° Movimiento",
						excelColumnsType: "string,string,datetime,money,string,string",
					};
				});
			} else {
				setPartial({ empty: true, message: response.message });
			}
		} else {
			setPartial({ error: true, message: response.message });
		}

		setPartial({ viviendas, propietarios, receipts: receiptList, loading: false });
	}, [setPartial]);

	// ---------- Otros fetchers ----------
	const getSubFraccionamientos = useCallback(async () => {
		const fraccionamiento = localStorage.getItem("frac");
		if (!fraccionamiento) return;

		const response = await request.post("/admin/administracion/get/subfraccionamientos", {
			Idsub: fraccionamiento,
			filter: 1,
		});

		if (response && !response.error) {
			if (response.subfraccionamiento && !response.empty) {
				setPartial({ subfraccionamientos: response.subfraccionamiento });
			} else {
				setPartial({ empty: true, message: response.message, subfraccionamientos: [] });
			}
		} else {
			setPartial({ error: true, message: response.message });
		}
	}, [setPartial]);

	const getFraccionamiento = useCallback(async () => {
		const frac = localStorage.getItem("frac");
		const response = await request.post("/admin/administracion/get/fraccionamiento", {
			IdFraccionamiento: frac,
		});
		if (response && !response.error && !response.empty) {
			setPartial({ frac_name: response.fraccionamiento[0].nombre });
		}
	}, [setPartial]);

	const getMetodoPagos = useCallback(async () => {
		const result = await request.get("/documentos/get/metodopago/recibo");
		if (result.empty || result.error) {
			setPartial({ metodosPago: [] });
		} else {
			setPartial({ metodosPago: result.metodos });
		}
	}, [setPartial]);

	// ---------- Mount ----------
	useEffect(() => {
		let cancelled = false;

		(async () => {
			const submenu = await context.getSubmenuAdminName();
			if (!cancelled && submenu) setPartial({ submenu });

			const permisos = new Permissions();
			const permisosInfo = await permisos.getResult();
			if (!cancelled) {
				setPartial({
					escritura: permisosInfo.escritura,
					lectura: permisosInfo.lectura,
				});
			}

			const user = await getUserInfo();
			if (!cancelled) {
				setPartial({ userName: user.info.usuario, userId: user.info.id_usuario });
			}
		})();

		getSubFraccionamientos();
		getMetodoPagos();
		getFraccionamiento();
		getReceipment();

		return () => { cancelled = true; };
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// ---------- Handlers ----------
	const setPage = useCallback((page) => setPartial({ page }), [setPartial]);
	const paginatorChange = useCallback((length) => setPartial({ pageLength: length, page: 1 }), [setPartial]);
	const getDataInvoice = useCallback(() => { getReceipment(); }, [getReceipment]);


	const setFilter = useCallback((value) => {
		setPartial({ filter: value.toLowerCase(), filterValue: value });
	}, [setPartial]);

	const subChange = useCallback(async (val) => {
		const parsed = parseInt(val);
		setPartial({ subfraccionamiento: parsed });
		await getReceipment({ subfraccionamiento: parsed });
	}, [getReceipment, setPartial]);

	const handleStartDateChange = useCallback((date) => {
		setPartial({
			startDate: date ? moment(date).format('YYYY-MM-DD') : '',
			startDateObj: date || null,
		});
	}, [setPartial]);

	const handleEndDateChange = useCallback((date) => {
		setPartial({
			endDate: date ? moment(date).format('YYYY-MM-DD') : '',
			endDateObj: date || null,
		});
	}, [setPartial]);

	const handleTipoChange = useCallback((event) => {
		setPartial({ filterTipo: event.target.value });
	}, [setPartial]);

	const sortableTable = useCallback((key) => {
		setState((prev) => {
			const sd = new sortableData();
			const { items, direction } = sd.sortBy(key, prev.receipts, prev.direction[key]);
			return {
				...prev,
				receipts: items,
				direction: { [key]: direction },
				filterColumn: { col: key, filt: direction },
			};
		});
	}, []);

	// ---------- Modal ----------
	const updateData = useCallback((json) => setPartial(json), [setPartial]);

	const clearNewReceipment = useCallback(() => {
		setPartial({
			isOpen: false,
			linesReceipment: [],
			dateReceipment: new Date(),
			aplicado: true,
		});
	}, [setPartial]);

	const beforeOpenNewReceipment = useCallback(() => {
		superOpenModal("newReceipment");

		const lines = Array.from({ length: 10 }, () => ({
			Id_Forma_Cobro: Math.ceil(Math.random() * 100) * Math.ceil(Math.random() * 100),
			Fecha_Pago: moment().format("YYYY-MM-DD"),
			Monto: 0,
			Id_FormaPago: 0,
			BANCO: "",
			NO_MOVIMIENTO: "",
			Id_Vivienda: 0,
			Edit: false,
			Text: "",
		}));

		setState((prev) => ({
			...prev,
			isOpen: true,
			dateReceipment: new Date(),
			aplicado: false,
			linesReceipment: lines,
			modalNewKey: prev.modalNewKey + 1,
		}));
	}, [superOpenModal]);

	const submitNewReceipment = useCallback(async () => {
		const s = stateRef.current;
		const lineas = s.linesReceipment.filter((l) => l.Edit === true && l.Monto > 0);
		setPartial({ savingReceipment: true });

		if (lineas.filter((l) => l.Id_Vivienda === 0).length > 0) {
			cogoToast.warn("Debe elegir vivienda en uno de los pagos.", { position: "bottom-right" });
		} else if (lineas.filter((l) => l.Id_FormaPago === 0).length > 0) {
			cogoToast.warn("Debe elegir forma de pago en uno de los pagos.", { position: "bottom-right" });
		} else if (lineas.length === 0) {
			cogoToast.warn("No se han agregado montos de pagos.", { position: "bottom-right" });
		} else {
			const data = {
				id_fraccionamiento: s.id_fraccionamiento,
				dateReceipment: s.dateReceipment,
				userId: s.userId,
				linespagos: JSON.stringify(lineas),
				userName: s.userName,
			};
			const res = await request.post("/receipment/create/new", data);
			if (res.error) {
				cogoToast.error("No fue posible crear el recibo.", { position: "bottom-right" });
			} else if (res.created) {
				cogoToast.success("Recibo guardado de manera correcta.", { position: "bottom-right" });
				clearNewReceipment();
				await getReceipment();
				superCloseModal("newReceipment");
			}
		}

		setPartial({ savingReceipment: false });
	}, [setPartial, clearNewReceipment, getReceipment, superCloseModal]);

	const openToEdit = useCallback(async (reciptObject) => {
		clearNewReceipment();
		superOpenModal("editReceipment");

		const fecha = moment(reciptObject.Fecha_recibo).format("YYYY-MM-DD HH:MM:ss");
		setState((prev) => ({
			...prev,
			isOpen: true,
			loadingDetalle: true,
			dateReceipment: new Date(fecha.toString()),
			aplicado: reciptObject.Estado_Cobro === 1,
			linesReceipment: [],
			idReceipment: reciptObject.Id_Recibo,
			modalEditKey: prev.modalEditKey + 1,
		}));

		const response = await request.get("/receipment/get/detail/receipment", {
			Id_Recibo: reciptObject.Id_Recibo,
		});

		if (response && !response.error && !response.empty) {
			const lista = response.data.map((rec) => {
				const f = moment(rec.Fecha_Pago).format("YYYY-MM-DD HH:MM:ss");
				rec.Fecha_Pago = new Date(f.toString());
				rec.Detalle = JSON.parse(rec.Detalle);
				return { ...rec, Edit: false };
			});

			if (reciptObject.Estado_Cobro === 0) {
				for (let i = 0; i < 15; i++) {
					lista.push({
						Id_Forma_Cobro: Math.ceil(Math.random() * 100) * Math.ceil(Math.random() * 100),
						Fecha_Pago: new Date(),
						Monto: 0,
						Id_FormaPago: 0,
						BANCO: "",
						NO_MOVIMIENTO: "",
						Id_Vivienda: 0,
						Edit: false,
					});
				}
			}

			setPartial({ linesReceipment: lista });
		}

		setPartial({ loadingDetalle: false });
	}, [clearNewReceipment, setPartial, superOpenModal]);

	const cancelReceipment = useCallback(async (reciptObject) => {
		const data = {
			Id_Recibo: reciptObject.Id_Recibo,
			userName: stateRef.current.userName,
		};
		const res = await request.post("/receipment/cancel", data);
		if (res.error) {
			cogoToast.error(res.message || "No fue posible cancelar el recibo.", { position: "bottom-right" });
		} else if (res.canceled) {
			cogoToast.success("Pago cancelado de manera correcta.", { position: "bottom-right" });
			await getReceipment();
		}
	}, [getReceipment]);

	// ---------- Render ----------
	const screens = [
		<NewReceipment
			key={`modal-${state.modalNewKey}-${state.modalEditKey}`}
			updateData={updateData}
			userName={state.userName}
			userId={state.userId}
			isOpen={state.isOpen}
			viviendas={state.viviendas}
			metodosPago={state.metodosPago}
			linesReceipment={state.linesReceipment}
			dateReceipment={state.dateReceipment}
			aplicado={state.aplicado}
			idReceipment={state.idReceipment}
			loadingDetalle={state.loadingDetalle}
		/>,
	];

	return (
		<div className="admin column">
			<Helmet>
				<title>{process.env.REACT_APP_NAME} - {state.submenu}</title>
				<style>{`
          #second_controls {
            position: sticky;
            top: 216px;
            z-index: 3;
            background-color: white;
          }
        `}</style>
			</Helmet>

			<Header
				reload={getReceipment}
				change={getReceipment}
				sidebar={true}
				active={"EstadosCuenta"}
				parent={"EstCuenta"}
				panel={"panel14"}
				nav={"administracion"}
			/>

			<div className="row">
				<div className="column" id="sidebar">
					<SidebarAdministracion />
				</div>

				<div className="column" id="content">
					<div className="justify-center">
						<div className="container column">
							<Controls
								title={state.submenu}
								nuevo={beforeOpenNewReceipment}
								dataSet={state.receipts}
								newButton={state.escritura}
								setFilter={setFilter}
								subChange={subChange}
								filterValue={state.filterValue}
							/>

							<div
								id="second_controls"
								className="row-responsive full"
								style={{ backgroundColor: "white", marginBottom: "16px" }}
							>
								<div className="data-from column full">
									<h5 className="color-black">DESDE:</h5>
									<UnifiedDatePicker
										selected={state.startDateObj}
										onChange={handleStartDateChange}
										includeTime={false}
										dateFormat="dd/MM/yyyy"
										placeholderText="DD/MM/YYYY"
										className="input input-text w-full"
										customInput={
											<InputMask
												mask="99/99/9999"
												maskChar={null}
												className="input input-text"
												placeholder="DD/MM/YYYY"
											/>
										}
									/>
								</div>
								<div style={{ width: "16px" }}></div>
								<div className="data-to column full">
									<h5 className="color-black">HASTA:</h5>
									<UnifiedDatePicker
										selected={state.endDateObj}
										onChange={handleEndDateChange}
										includeTime={false}
										dateFormat="dd/MM/yyyy"
										placeholderText="DD/MM/YYYY"
										className="input input-text w-full"
										customInput={
											<InputMask
												mask="99/99/9999"
												maskChar={null}
												className="input input-text"
												placeholder="DD/MM/YYYY"
											/>
										}
									/>
								</div>
								<div style={{ width: "24px" }}></div>
								<div className="data-to column full">
									<h5 className="color-black">TIPO:</h5>
									<select
										className="input input-select"
										value={state.filterTipo}
										onChange={handleTipoChange}
									>
										<option value="">Todos</option>
										<option value="Cheque Nominativo">Cheque Nominativo</option>
										<option value="Efectivo">Efectivo</option>
										<option value="Tarjeta de crédito">Tarjeta de Crédito</option>
									</select>
								</div>
								<div style={{ width: "24px" }}></div>
								<div className="data-to column justify-end" style={{ maxWidth: '80px' }}>
									<button
										type="button"
										className="btn btn-primary btn-small color-white justify-center"
										onClick={getDataInvoice}
									>
										Buscar
									</button>
								</div>
							</div>

							{state.loading ? (
								<div className="row justify-center">
									<i className="fas fa-spinner fa-spin"></i>
								</div>
							) : (
								<ReceipmentTable
									receipts={state.receipts}
									page={state.page}
									openToEdit={openToEdit}
									filter={state.filter}
									pageLength={state.pageLength}
									escritura={state.escritura}
									cancelReceipment={cancelReceipment}
									sortBy={sortableTable}
									filterColumn={state.filterColumn}
									idReceipment={state.idReceipment}
								/>
							)}

							<div className="white-space-16"></div>

							<Paginador
								pages={Math.ceil(state.receipts.length / state.pageLength)}
								setPage={setPage}
								pageLength={state.pageLength}
								paginatorChange={paginatorChange}
								showPageLenght={true}
							/>
						</div>
					</div>
				</div>
			</div>

			<SuperModal
				id={"newReceipment"}
				size={"huge"}
				title={"Aplicar pago"}
				screens={screens}
				onSubmit={submitNewReceipment}
				lblSubmit={"Aplicar"}
				showSubmit={true}
				loading={state.savingReceipment}
				triggerCloseModal={clearNewReceipment}
				deshabilitarEsc={true}
			/>

			<SuperModal
				id={"editReceipment"}
				size={"huge"}
				title={"Detalle pago"}
				screens={screens}
				onSubmit={() => { }}
				lblSubmit={"Aplicar"}
				showSubmit={false}
				triggerCloseModal={clearNewReceipment}
			/>
		</div>
	);
}

// ============================================================
// Wrapper minimo, heredo SuperCore pa conservar
// superOpenModal / superCloseModal / getUserInfo
// ============================================================
class ReceipmentPaymentWrapper extends SuperCore {
	render() {
		return (
			<ReceipmentPaymentInner
				context={this.props.context}
				superOpenModal={this.superOpenModal.bind(this)}
				superCloseModal={this.superCloseModal.bind(this)}
				getUserInfo={this.getUserInfo.bind(this)}
			/>
		);
	}
}

export default Consumer(ReceipmentPaymentWrapper);